<template>
  <template v-if="layout === 'table'">
    <tr style="background-color: white !important">
      <td>
        <div class="form-check form-check-sm form-check-custom form-check-solid">
          <input class="form-check-input widget-9-check" type="checkbox" disabled />
        </div>
      </td>
      <td>
        <div class="d-flex align-items-center">
          <div class="d-flex justify-content-start flex-column">
            <select
              v-model="form.con_civilite"
              class="form-select form-select-lg form-select-solid mt-2"
              style="width: 100%; display: block; border: 1px solid #dcdfe6; height: 43px"
            >
              <option :value="0">{{ $t("Monsieur") }}</option>
              <option :value="1">{{ $t("Madame") }}</option>
            </select>
            <input
              v-model="form.con_prenom"
              :placeholder="$t('Prénom')"
              class="form-control form-control form-control-solid mt-2"
              style="width: 100%; display: block"
            />
            <input
              v-model="form.con_nom"
              :placeholder="$t('Nom')"
              class="form-control form-control form-control-solid mt-2"
              style="width: 100%; display: block"
            />
          </div>
        </div>
      </td>
      <td>
        <input
          v-model="form.con_tel1"
          :placeholder="$t('Télephone Fixe')"
          class="form-control form-control form-control-solid mt-2"
        />
        <input
          v-model="form.con_tel2"
          :placeholder="$t('Télephone Mobile')"
          class="form-control form-control form-control-solid mt-2"
        />
        <input
          v-model="form.con_mail"
          :placeholder="$t('Adresse mail')"
          class="form-control form-control form-control-solid mt-2"
        />
      </td>
    </tr>
    <tr style="background-color: white !important; text-align: right">
      <td colspan="3">
        <button
          type="button"
          class="btn btn-sm btn-active-secondary me-2 mb-2 btn-bg-white btn-text-dark"
          :disabled="saving"
          @click="onCancel"
        >
          {{ $t("Annuler") }}
        </button>
        <button
          type="button"
          class="btn btn-sm btn-active-secondary me-2 mb-2 btn-bg-primary btn-text-white"
          :disabled="saving"
          @click="saveContact"
        >
          {{ $t("Créer le contact") }}
        </button>
      </td>
    </tr>
  </template>

  <div v-else class="contact-quick-create-card">
    <div class="row g-5">
      <div class="col-md-6">
        <label class="form-label fw-bold fs-6">{{ $t("Civilité") }}</label>
        <select v-model="form.con_civilite" class="form-select form-select-solid">
          <option :value="0">{{ $t("Monsieur") }}</option>
          <option :value="1">{{ $t("Madame") }}</option>
        </select>
      </div>
      <div class="col-md-6">
        <label class="form-label fw-bold fs-6">{{ $t("Prénom") }}</label>
        <input v-model="form.con_prenom" :placeholder="$t('Prénom')" class="form-control form-control-solid" />
      </div>
      <div class="col-md-6">
        <label class="form-label fw-bold fs-6">{{ $t("Nom") }}</label>
        <input v-model="form.con_nom" :placeholder="$t('Nom')" class="form-control form-control-solid" />
      </div>
      <div class="col-md-6">
        <label class="form-label fw-bold fs-6">{{ $t("Télephone Fixe") }}</label>
        <input v-model="form.con_tel1" :placeholder="$t('Télephone Fixe')" class="form-control form-control-solid" />
      </div>
      <div class="col-md-6">
        <label class="form-label fw-bold fs-6">{{ $t("Télephone Mobile") }}</label>
        <input v-model="form.con_tel2" :placeholder="$t('Télephone Mobile')" class="form-control form-control-solid" />
      </div>
      <div class="col-md-6">
        <label class="form-label fw-bold fs-6">{{ $t("Adresse mail") }}</label>
        <input v-model="form.con_mail" :placeholder="$t('Adresse mail')" class="form-control form-control-solid" />
      </div>
    </div>
    <div class="d-flex justify-content-end gap-2 mt-8">
      <button type="button" class="btn btn-light" :disabled="saving" @click="onCancel">
        {{ $t("Annuler") }}
      </button>
      <button type="button" class="btn btn-primary" :disabled="saving" @click="saveContact">
        {{ $t("Créer le contact") }}
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, reactive, ref } from "vue";
import mAxiosApi from "@/api";
import { ElMessage } from "element-plus";
import { useI18n } from "vue-i18n";

export default defineComponent({
  name: "contact-quick-create",
  props: {
    linkToSite: {
      type: Number,
      default: null,
    },
    clientSociete: {
      type: Number,
      default: null,
    },
    layout: {
      type: String,
      default: "card",
      validator: (v: string) => ["card", "table"].includes(v),
    },
  },
  emits: ["created", "cancel"],
  setup(props, { emit }) {
    const { t } = useI18n();
    const saving = ref(false);

    const form = reactive({
      con_civilite: 0,
      con_prenom: "",
      con_nom: "",
      con_tel1: "",
      con_tel2: "",
      con_mail: "",
    });

    const resetForm = () => {
      form.con_civilite = 0;
      form.con_prenom = "";
      form.con_nom = "";
      form.con_tel1 = "";
      form.con_tel2 = "";
      form.con_mail = "";
    };

    const onCancel = () => {
      resetForm();
      emit("cancel");
    };

    const saveContact = async () => {
      if (!form.con_prenom.trim() || !form.con_nom.trim()) {
        ElMessage({
          showClose: true,
          message: t("Veuillez renseigner le prénom et le nom du contact."),
          type: "error",
        });
        return;
      }

      const payload: Record<string, unknown> = {
        con_civilite: form.con_civilite,
        con_prenom: form.con_prenom.trim(),
        con_nom: form.con_nom.trim(),
        con_tel1: form.con_tel1,
        con_tel2: form.con_tel2,
        con_mail: form.con_mail,
      };

      if (props.linkToSite && props.linkToSite > 0) {
        payload.con_knum_adr = props.linkToSite;
      }

      if (props.clientSociete && props.clientSociete > 0) {
        payload.con_knum_societe = props.clientSociete;
      }

      saving.value = true;
      try {
        const response = await mAxiosApi.post("addContact", payload);
        const results = response.data?.results;
        const conSeq =
          results && typeof results === "object" && results.con_seq
            ? Number(results.con_seq)
            : 0;

        emit("created", {
          con_seq: conSeq,
          con_prenom: form.con_prenom.trim(),
          con_nom: form.con_nom.trim(),
          con_mail: form.con_mail,
          con_tel1: form.con_tel1,
          con_tel2: form.con_tel2,
        });
        resetForm();
      } catch (err) {
        console.error(err);
        ElMessage({
          showClose: true,
          message: t("Une erreur est survenue lors de la création du contact."),
          type: "error",
        });
      } finally {
        saving.value = false;
      }
    };

    return {
      form,
      saving,
      onCancel,
      saveContact,
    };
  },
});
</script>
